function syncFrame2ContentScale() {
  const frame = document.querySelector('#frame2');
  if (!frame) return;

  const viewportRatio = window.innerWidth / window.innerHeight;
  const isWideDesktop = window.innerWidth > 768 && viewportRatio > 2.05;
  const fitScale = isWideDesktop ? Math.min(1, 2 / viewportRatio) : 1;
  frame.style.setProperty('--frame2-content-scale', fitScale.toFixed(4));
}

window.addEventListener("load", function () {
  syncFrame2ContentScale();
});

window.addEventListener('resize', syncFrame2ContentScale, { passive: true });
